import { Link } from "react-router-dom";

const localities = [
  { name: "Sion", path: "/sion", desc: "Capitale du Valais" },
  { name: "Sierre", path: "/sierre", desc: "Ville du soleil" },
  { name: "Martigny", path: "/martigny", desc: "Carrefour du Valais" },
  { name: "Grône", path: "/grone", desc: "Village valaisan" },
  { name: "Crans-Montana", path: "/crans-montana", desc: "Station alpine" },
  { name: "Verbier", path: "/verbier", desc: "Station de ski" },
  { name: "Nendaz", path: "/nendaz", desc: "Domaine skiable" },
  { name: "Vercorin", path: "/vercorin", desc: "Village d'altitude" },
  { name: "Nax", path: "/nax", desc: "Mont-Noble" },
];

export default function LocalitiesSection() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <span className="text-xs uppercase tracking-widest text-amber-700 font-medium">
            Zones d&apos;intervention
          </span>
          <h2 className="mt-3 text-4xl font-bold text-stone-900">
            Nous intervenons dans <strong>tout le Valais</strong>
          </h2>
          <p className="mt-4 text-stone-500 max-w-xl mx-auto text-sm leading-relaxed">
            On intervient dans 9 localités valaisannes. Déplacement rapide, on
            vient voir sur place.
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {localities.map((loc) => (
            <Link
              key={loc.name}
              to={loc.path}
              className="group flex items-center gap-2 px-5 py-2.5 bg-stone-50 rounded-full border border-stone-200 hover:border-amber-500 hover:bg-amber-50 transition-all cursor-pointer"
            >
              <span className="w-1.5 h-1.5 rounded-full bg-amber-500 group-hover:scale-125 transition-transform" />
              <span className="text-sm font-medium text-stone-700 group-hover:text-amber-800 whitespace-nowrap">
                {loc.name}
              </span>
              <span className="text-xs text-stone-400 hidden sm:inline">
                {loc.desc}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}